import Footer from "../components/Footer";
import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import AnimatedPage from "../components/AnimatedPage";

function ListXS() {
    const navigate = useNavigate();
    const handleBackClick = () => {
        navigate("/");
    };
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    /*const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile")));
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile != res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);*/
    const date0 = new Date();
    const currentHour = date0.getHours();
    const [dateMT, setDateMT] = useState(date0.getDay());
    const [dataMT, setDataMT] = useState();
    const [imageMT, setImageMT] = useState([]);
    const handleChangeMT = (e) => {
        setDateMT(e.target.value);
        //setDataMT(null);
    };
    const [dateMN, setDateMN] = useState(date0.getDay());
    const [dataMN, setDataMN] = useState([]);
    const [imageMN, setImageMN] = useState([]);
    const handleChangeMN = (e) => {
        setDateMN(e.target.value);
        //setDataMN(null);
    };
    useEffect(() => {
        if (dateMT == 0) {
            if (currentHour < 18) {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            } else {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            }
        }
        if (dateMT == 1) {
            if (currentHour < 18) {
                setDataMT(["phye", "thth"]);
                setImageMT(["phuyen", "hue"]);
            } else {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            }
        }
        if (dateMT == 2) {
            if (currentHour < 18) {
                setDataMT(["dalak", "quna"]);
                setImageMT(["daklak", "quangnam"]);
            } else {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            }
        }
        if (dateMT == 3) {
            if (currentHour < 18) {
                setDataMT(["dana", "khho"]);
                setImageMT(["danang", "khanhhoa"]);
            } else {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            }
        }
        if (dateMT == 4) {
            if (currentHour < 18) {
                setDataMT(["qubi", "bidi", "qutr"]);
                setImageMT(["quangbinh", "binhdinh", "quangtri"]);
            } else {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            }
        }
        if (dateMT == 5) {
            if (currentHour < 18) {
                setDataMT(["gila", "nith"]);
                setImageMT(["gialai", "ninhthuan"]);
            } else {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            }
        }
        if (dateMT == 6) {
            if (currentHour < 18) {
                setDataMT(["dana", "qung", "dano"]);
                setImageMT(["danang", "quangngai", "daknong"]);
            } else {
                setDataMT(["khho", "kotu", "thth"]);
                setImageMT(["khanhhoa", "komtum", "hue"]);
            }
        }
    }, [dateMT]);
    useEffect(() => {
        if (dateMN == 0) {
            if (currentHour < 17) {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            } else {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            }
        }
        if (dateMN == 1) {
            if (currentHour < 17) {
                setDataMN(["cama", "doth", "tphc"]);
                setImageMN(["camau", "dongthap", "tphcm"]);
            } else {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            }
        }
        if (dateMN == 2) {
            if (currentHour < 17) {
                setDataMN(["bali", "vuta", "betr"]);
                setImageMN(["baclieu", "vungtau", "bentre"]);
            } else {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            }
        }
        if (dateMN == 3) {
            if (currentHour < 17) {
                setDataMN(["cath", "dona", "sotr"]);
                setImageMN(["cantho", "dongnai", "soctrang"]);
            } else {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            }
        }
        if (dateMN == 4) {
            if (currentHour < 17) {
                setDataMN(["angi", "bith", "tani"]);
                setImageMN(["angiang", "binhthuan", "tayninh"]);
            } else {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            }
        }
        if (dateMN == 5) {
            if (currentHour < 17) {
                setDataMN(["bidu", "trvi", "vilo"]);
                setImageMN(["binhduong", "travinh", "vinhlong"]);
            } else {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            }
        }
        if (dateMN == 6) {
            if (currentHour < 17) {
                setDataMN(["biph", "hagi", "loan", "tphc"]);
                setImageMN(["binhphuoc", "haugiang", "longan", "tphcm"]);
            } else {
                setDataMN(["dalat", "kigi", "tigi"]);
                setImageMN(["dalat", "kiengiang", "tiengiang"]);
            }
        }
    }, [dateMN]);
    return (
        <>
            <div className="title-top">
                <div className="back" onClick={handleBackClick}>
                    <KeyboardArrowLeftOutlinedIcon />
                </div>
                <h1 className="title-h1">Xổ số</h1>
            </div>
            <div style={{ padding: "0 0 2rem" }}>
                <AnimatedPage>
                    {dataMT && dataMN ? (
                        <>
                            <div className="">
                                <div className="title-xs">
                                    <div className="title-gradient">Miền Bắc</div>
                                    <div className="select-box"></div>
                                </div>
                                <div className="list-xs">
                                    <Link to="/xsmb/lo2" style={{ width: "33.33%" }}>
                                        <div className="item">
                                            <img alt="" src={require(`../../images/3mien/mienbac.png`)} />
                                            <div className="dat-cuoc">Đặt cược</div>
                                        </div>
                                    </Link>
                                    <Link to="/xs120s/lo2" style={{ width: "33.33%" }}>
                                        <div className="item">
                                            <img alt="" src={require(`../../images/mb2p.png`)} style={{ padding: "5px 5px 0" }} />
                                            <div className="dat-cuoc">Đặt cược</div>
                                        </div>
                                    </Link>
                                    <Link to="/xs75s/lo2" style={{ width: "33.33%" }}>
                                        <div className="item">
                                            <img alt="" src={require(`../../images/mb75g.png`)} style={{ padding: "5px 5px 0" }} />
                                            <div className="dat-cuoc">Đặt cược</div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="">
                                <div className="title-xs">
                                    <div className="title-gradient">Miền Trung</div>
                                    <div className="select-box">
                                        <select onChange={handleChangeMT} value={dateMT}>
                                            <option value="0">Chủ nhật</option>
                                            <option value="1">Thứ 2</option>
                                            <option value="2">Thứ 3</option>
                                            <option value="3">Thứ 4</option>
                                            <option value="4">Thứ 5</option>
                                            <option value="5">Thứ 6</option>
                                            <option value="6">Thứ 7</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="list-xs">
                                    {dataMT?.map((item, index) => (
                                        <>
                                            <Link to={`/xsmt/lo2/${item}`} key={item}>
                                                <div className="item">
                                                    <img alt="" src={require(`../../images/3mien/${imageMT[index]}.png`)} />
                                                    <div className="dat-cuoc">Đặt cược</div>
                                                </div>
                                            </Link>
                                        </>
                                    ))}
                                </div>
                            </div>
                            <div className="">
                                <div className="title-xs">
                                    <div className="title-gradient">Miền Nam</div>
                                    <div className="select-box">
                                        <select onChange={handleChangeMN} value={dateMN}>
                                            <option value="0">Chủ nhật</option>
                                            <option value="1">Thứ 2</option>
                                            <option value="2">Thứ 3</option>
                                            <option value="3">Thứ 4</option>
                                            <option value="4">Thứ 5</option>
                                            <option value="5">Thứ 6</option>
                                            <option value="6">Thứ 7</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="list-xs">
                                    {dataMN?.map((item, index) => (
                                        <>
                                            <Link to={`/xsmn/lo2/${item}`} key={item}>
                                                <div className="item">
                                                    <img alt="" src={require(`../../images/3mien/${imageMN[index]}.png`)} />
                                                    <div className="dat-cuoc">Đặt cược</div>
                                                </div>
                                            </Link>
                                        </>
                                    ))}
                                </div>
                            </div>
                        </>
                    ) : null}
                </AnimatedPage>
            </div>
            <Footer />
        </>
    );
}
export default ListXS;
